module.exports = __webpack_public_path__ + "static/img/6.324ca3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/6.png
// module id = HFEm
// module chunks = 0